/**
 * Plugin Manager — Sprint 6A facade over PluginHost.
 *
 * Plugins subscribe to the Playback Event Bus only.
 * They must never talk to providers directly.
 */
import { createPluginHost } from "./PluginHost";
import { PLUGIN_FORWARDED_EVENTS } from "./pluginForwardedEvents";

export { PLUGIN_FORWARDED_EVENTS } from "./pluginForwardedEvents";

/**
 * @param {object} engine
 * @param {object} config
 * @param {object} [extras]
 * @returns {object}
 */
export function createPluginManager(engine, config, extras) {
  var host = createPluginHost(engine, config, extras, {
    forwardEvents: PLUGIN_FORWARDED_EVENTS,
  });

  return Object.assign(host, {
    addPlugin: host.register,
    addPlugins: host.registerMany,
    removePlugin: host.unregister,
    getEventBus: function () {
      return host.bus;
    },
  });
}

export default createPluginManager;
